export default function retrieveReviewPageType() {
  return localStorage.getItem("review_page_type");
}
